import SocialMediaEdit from './socialMediaEdit'
export default SocialMediaEdit
